import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { SalesPage } from './pages/SalesPage';
import { siteConfig } from './data/siteConfig';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel(siteConfig.metaPixelId);
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3fbj8evsndfrq">
      <SalesPage data-id="element-1" data-mp="3f8nd7f86p56z" />
    </MotionConfig>;
}